import { queryOptions } from "@tanstack/react-query"
import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"
import { getStoreWithConfigurations } from "@/features/project-editor/server/projectServer"
import { authFunctionMiddleware } from "@/lib/auth-middleware"

const Params = z.object({
  storeId: z.string(),
})

const getStoreDetails = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .inputValidator(Params)
  .handler(async ({ data }) => {
    return await getStoreWithConfigurations({ data })
  })

/**
 * Query configuration for store detail
 */
export const storeDetailQuery = (params: z.infer<typeof Params>) =>
  queryOptions({
    queryKey: ["store-detail", params.storeId],
    queryFn: () => getStoreDetails({ data: params }),
  })
